import React from 'react';
import {Box} from '@mui/material';
import {DataGridPro} from '@mui/x-data-grid-pro';
import {MeetingTabs} from './components/MeetingTabs';

import Loading from '../../components/Loading/Loading';
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage';
import {useGetInvitations} from './invitationQueries';
import {InvitationReviewsInput} from '../../schema-types/globalTypes';
import {
  accountNameColumn,
  clientsColumn,
  ownerColumn,
  propositionTypeColumn,
  scheduledForTimeOnlyColumn,
  locationColumn,
  rtqStatusColumn,
  ecqStatusColumn,
} from './invitationColumns';

const TodayInner: React.FC = () => {
  const {data, error, loading} = useGetInvitations({
    inviteStatus: InvitationReviewsInput.TODAYS_MEETINGS,
  });

  // Loading state
  if (loading) {
    return <Loading entityName="today's meetings" />;
  }

  // Error state
  if (error) {
    return <ErrorMessage error={error} />;
  }

  // No data state
  if (!data?.getInvitationReviews?.reviews) {
    return <Box>No meetings scheduled for today</Box>;
  }

  const {reviews} = data.getInvitationReviews;

  // DataGrid columns - using ReviewDetailsFragment fields
  const columns = [
    accountNameColumn,
    clientsColumn,
    ownerColumn,
    propositionTypeColumn,
    scheduledForTimeOnlyColumn,
    locationColumn,
    rtqStatusColumn(false),
    ecqStatusColumn(false),
  ];

  return (
    <Box sx={{height: 600, width: '100%'}}>
      <DataGridPro rows={reviews} columns={columns} disableRowSelectionOnClick />
    </Box>
  );
};

export const TodayPage: React.FC = () => {
  return (
    <>
      <MeetingTabs />
      <TodayInner />
    </>
  );
};
